export default {
  map_unavailable: 'Kortet kunne ikke indlæses. Genindlæs siden, og prøv igen.',
  stubs: {
    name: 'Leveringszone {{number}}',
  },
  buttons: {
    add_new_zone: 'Tilføj ny zone',
  },
  toasts: {
    failed_to_load_data: 'Leveringszonerne kunne ikke indlæses',
  },
};
